var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.sbvisible,
        "append-to-body": true,
        width: "40%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.sbvisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "tipsBox" }, [
        _c("img", {
          staticStyle: { width: "20px", height: "20px" },
          attrs: { src: require("./static/tips.png") },
        }),
        _c("span", [_vm._v("支持通过司机姓名、手机号搜索司机！")]),
      ]),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, size: "small", "label-width": "80px" },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _vm.info.orderStatus === 3
                ? _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("el-form-item", { attrs: { label: "原司机:" } }, [
                        _vm.info.driverOperationInfoList !== null &&
                        _vm.info.driverOperationInfoList.length
                          ? _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.info.driverOperationInfoList[0]
                                      .driverName
                                  ) +
                                  "\n            " +
                                  _vm._s(
                                    _vm.info.driverOperationInfoList[0]
                                      .driverPhone
                                  ) +
                                  "\n            " +
                                  _vm._s(
                                    _vm.info.driverOperationInfoList[0]
                                      .plateNumber
                                  ) +
                                  "\n            " +
                                  _vm._s(
                                    _vm.info.driverOperationInfoList[0]
                                      .merchantName
                                  ) +
                                  "\n          "
                              ),
                            ])
                          : _c("span"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择：", prop: "driverId" } },
                    [
                      _c("avue-select", {
                        staticStyle: { width: "30vw" },
                        attrs: {
                          dic: _vm.driverDic,
                          props: { label: "driverInfo", value: "driverId" },
                          placeholder: "试试搜索: 请选择司机",
                          filterable: "",
                        },
                        on: { change: _vm.handleChange },
                        model: {
                          value: _vm.info.driverId,
                          callback: function ($$v) {
                            _vm.$set(_vm.info, "driverId", $$v)
                          },
                          expression: "info.driverId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注:", prop: "operationRemark" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "30vw" },
                        attrs: {
                          type: "textarea",
                          rows: 2,
                          placeholder: "备注",
                        },
                        model: {
                          value: _vm.form.operationRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "operationRemark", $$v)
                          },
                          expression: "form.operationRemark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "font-12 margin-left-25",
          staticStyle: { color: "#9f9f9f" },
        },
        [
          _c("div", [_vm._v("指派/改派查询车司信息:")]),
          _c("div", [
            _vm._v(
              "1、城际车：只能被指派/改派，自己所服务的班次的摆渡订单，且司机、车辆状态正常"
            ),
          ]),
          _c("div", [
            _vm._v(
              "2、摆渡车：司机、车辆所属供应商有对应线路、对应区域的接送计价，且司机、车辆状态正常"
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "small" },
              on: { click: _vm.cancel },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.sumit },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }